export default __webpack_public_path__ + "static/media/banner-1-bg.b782f6ef.mp4";